import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import type { ErgebnisInput } from '../../interfaces/ergebnis-input.model';
import { ResultsItemComponent } from '../results-item/results-item.component';
import { ServiceErrorModalComponent } from './service-error-modal/service-error-modal.component';

@Component({
  selector: 'ui-results-item-error',
  templateUrl: './results-item-error.component.html',
  styleUrl: './results-item-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ResultsItemComponent, MatIcon],
})
export class ResultsItemErrorComponent {
  readonly icon = input<string>();
  readonly ergebnis = input.required<ErgebnisInput>();
  private readonly dialog = inject(MatDialog);

  protected openTarifErrorDialog() {
    this.dialog.open(ServiceErrorModalComponent, {
      data: (this.ergebnis().webserviceMeldungen ?? []).map(item => item.text).join('\n'),
    });
  }
}
